import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {mbeConfigService} from './mbe-config.service';
import {Observable} from 'rxjs';
import {BasicResponse, SortFilterInterface} from '@auth-suite-services/services';
import { SourceGroupTemp, SourceGroupTempAPI } from '../model/source-group';

@Injectable({
  providedIn: 'root',
})
export class SourceGroupTempService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url +
      '/sgt';
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllSGT(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter?: SortFilterInterface
  ): Observable<SourceGroupTempAPI> {
    console.log('SGT Service - getAllSGT called with:');
    console.log('pageIndex:', pageIndex);
    console.log('pageSize:', pageSize);
    console.log('sortActive:', sortActive);
    console.log('sort:', sort);
    console.log('sortFilter:', sortFilter);
    console.log('sortFilter type:', typeof sortFilter);
    console.log('sortFilter JSON:', JSON.stringify(sortFilter));
    
    // Clean the sortFilter object to remove any non-serializable properties. 03/10/2025 PK.
    let cleanSortFilter: { sort?: unknown; filter?: unknown } | null = null;
    if (sortFilter) {
      cleanSortFilter = {
        sort: sortFilter.sort,
        filter: sortFilter.filter
      };
      console.log('Cleaned sortFilter:', cleanSortFilter);
      console.log('Cleaned sortFilter JSON:', JSON.stringify(cleanSortFilter));
    }
    // Send empty object when no filter so backend receives valid JSON (avoids parsing error). 10/03/2026 PK.
    const body = cleanSortFilter ?? {};
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<SourceGroupTempAPI>(
      `${this.URL}/allsgt/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      body,
      { headers }
    );
  }

  getSGT(id: number): Observable<SourceGroupTemp> {
    console.log('SGR ID');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<SourceGroupTemp>(`${this.URL}/getsgt/${id}`, {
      headers,
    });
  }

  updateSGT(sgt: SourceGroupTemp): Observable<BasicResponse> {
    console.log('Update sgt' + JSON.stringify(sgt));
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/updatesgt`, sgt, {
      headers,
    });
  }

  // Added new method to import SGT. 02/10/2025 PK.
  importSGT(): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/importsgt`, {}, {
      headers,
    });
  }

  createSGT(sgt: SourceGroupTemp): Observable<BasicResponse> {
    console.log('Create sgt' + JSON.stringify(sgt));
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/createsgt`, sgt, {
      headers,
    });
  }
}
